module.exports = __webpack_public_path__ + "static/media/9DESA12.689bfa59.jpg";